export const environment = {
    production: true,
    region: 'ap-southeast-2',
    endpoint: 'https://api.eyewatch.org.au',
    logLevel: 'debug',
    buildId: process.env.NG_APP_BUILD_ID || 'local',
    defaultCollectionLimit: 20,
    enableSentry: true,
    nextview_url: 'https://quality.eyewatch.org.au',
    timeZone: 'Australia/Brisbane'
};
